// JavaScript Document

/* Brand List */
function beautybrandli(callback,append){
var beautybrandlist = "";
    $.ajax({
        url: '//www.kontatsu.co.jp/wp/wp-content/themes/kontatsu-child/assets/json/' + callback + '.jsonp',
        type:"GET",
        dataType:"jsonp",
	jsonpCallback: callback,
        error:function() {
//            alert("�����ɼ���");
        },
        success: function(json){
	 	var len = json.length;
    		for(var i=0; i < len; i++){

if(json[i].logo){
    beautybrandlist = '<li class="swiper-slide"><a href="' + json[i].url_o + '" target="_top">' + '<h3>' + json[i].name + '</h3><div><img src="' + json[i].logo + '" alt="' + json[i].name + '"></div><p>' + json[i].cap + '</p></a></li>';
} else {
    beautybrandlist = '<li class="swiper-slide"><a href="' + json[i].url_o + '" target="_top">' + '<img src="' + json[i].img + '" alt="' + json[i].name + '"><p>' + json[i].cap + '</p></a></li>';
}

/*				if(json[i].url != ""){
					brandlist = '<li><a href="' + json[i].url_o + '" target="_top">' + '<img src="' + json[i].img + '" alt="' + json[i].name + '"><div><img src="' + json[i].logo + '" alt="' + json[i].name + '"></div><p>' + json[i].cap + '</p></a></li>';
				}*/
   				$(append).append(beautybrandlist);
   			}
		}
    })
};